import React, { FC } from "react"
import { RRButtonFooter } from "../../atoms/roundedrectangle/RRButtonFooter"
import { StatusBubble } from "../../atoms/Atoms"
import { RRIconBar } from "../../atoms/roundedrectangle/RRIconBar"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../../atoms/Bodies"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { useBenefitEnrollment } from "components/context/enrollment/BenefitEnrollmentContext"
import { BenefitAvailabilityStatus } from "types/benefitEnrollmentStatus"
import { useHistory } from "react-router-dom"
import Locations from "components/views/home/navigation"
import { FormattedMessage, useIntl } from "react-intl"

const CarrotCardNeedsEnrollmentModule: FC<CarrotCardModuleProps> = () => {
  const { availabilityStatus, status } = useBenefitEnrollment()
  const history = useHistory()
  const intl = useIntl()

  const onClickUpdate = (): void => history.push(Locations.Home.EnrollmentFlowActive)

  const isExpired = availabilityStatus === BenefitAvailabilityStatus.ENROLLMENT_PLAN_EXPIRED

  const expiredBodyMessage = status.cardLockedDueToNeedsEnrollmentDateTime
    ? intl.formatMessage(
        {
          defaultMessage:
            "Your Carrot Card and funds have been locked because your insurance plan info expired {formattedDate}"
        },
        {
          formattedDate: intl.formatDate(status.cardLockedDueToNeedsEnrollmentDateTime, {
            year: "numeric",
            month: "long",
            day: "numeric"
          })
        }
      )
    : intl.formatMessage({
        defaultMessage: "Your Carrot Card and funds have been locked because your insurance plan info expired"
      })

  const bodyMessage = isExpired
    ? expiredBodyMessage
    : intl.formatMessage({
        defaultMessage:
          "Your Carrot benefit has been updated. To access your funds, you'll need to share some information about your insurance plan."
      })

  const buttonLabel = isExpired
    ? intl.formatMessage({ defaultMessage: "Update plan info" })
    : intl.formatMessage({ defaultMessage: "Share plan info" })

  return (
    <RoundedRectangle backgroundColor="red-orange-white">
      <RRIconBar
        iconName="icn-carrot-cards"
        iconBackgroundColor="roman-red-40"
        label={<StatusBubble backgroundColor="roman-red" status={intl.formatMessage({ defaultMessage: "Locked" })} />}
      />
      <H3 variant="primary" stack="tiny">
        <FormattedMessage defaultMessage="Carrot Card®" />
      </H3>
      <BodySmall color="black-80">{bodyMessage}</BodySmall>
      <RRButtonFooter onClick={onClickUpdate} outline>
        {buttonLabel}
      </RRButtonFooter>
    </RoundedRectangle>
  )
}

export { CarrotCardNeedsEnrollmentModule }
